import React from "react";
import mercury_cover from "../assets/mercury.jpg";
import CloseButton from "../layout_components/CloseButton";
const Mercury = ({ closeComponent }) => {
  return (
    <div className="detail-container">
      <CloseButton closeComponent={closeComponent} />
      <img
        src={mercury_cover}
        alt="Mercury-Cover"
        className="first-page-img"
      ></img>
      <h3 className="subtitle">First Page of Paper</h3>
      <div className="text-part">
        <h3 className="headline">Themis - QoS Memory System</h3>
        <h4 className="time-info">May 2023 — June 2024 (paper still in submission)</h4>

        <h4 className="description">
          In May 2023, I began working under the supervision of{" "}
          <a
            href="https://mosharaf.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            {" "}
            Dr. Mosharf Chowdhury
          </a>{" "}
          at the University of Michigan on developing{" "}
          <span className="text-violet-500">Mercury</span>, a QoS-aware tiered
          memory system designed to address the growing memory demands of
          memory-intensive applications. While existing tiered memory systems
          offer increased capacity to accommodate more applications, they lack
          robust support for{" "}
          <span className="text-violet-500">Quality-of-Service (QoS)</span>,
          leading to significant performance drops when multiple applications
          share the system. In fact, applications often suffer up to a 70%
          reduction in performance due to local memory contention and bandwidth
          interference—two issues that are unique to tiered memory systems.
        </h4>

        <h4 className="description">
          To solve this, Mercury introduces a novel solution by enforcing
          application-level resource management through{" "}
          <span className="text-violet-500">per-tier page reclamation</span>{" "}
          and leveraging an innovative{" "}
          <span className="text-violet-500">
            admission control and real-time adaptation algorithm
          </span>
          . These features maximize memory utilization and minimize
          interference, ensuring predictable performance for coexisting
          applications with different{" "}
          <span className="text-violet-500">Service-Level Objectives (SLOs)</span>
          .
        </h4>

        <h4 className="description">
          As a Research Assistant, I played a crucial role in the design and
          testing of this system. I led performance experiments using Docker and
          Intel Platform QoS tools, focusing on latency-sensitive applications
          like Redis and bandwidth-heavy applications like Llama. By simulating
          real-world workloads, I assessed system performance under varying
          conditions of memory contention and interference, contributing to the
          fine-tuning of the Mercury system’s adaptive algorithms. My work
          directly supported the improvement of memory access efficiency,
          leading to performance gains of up to{" "}
          <span className="text-violet-500">53.4%</span> for applications
          sharing the tiered memory system.
        </h4>

        <h4 className="description end-text">
          I also contributed to the paper development and revision process, and
          the work is still in submission. This project strengthened my systems
          research background and gave me hands-on experience with performance
          evaluation for modern memory-intensive workloads.
        </h4>
      </div>
    </div>
  );
};

export default Mercury;
